module.exports = __webpack_public_path__ + "img/jhlogo.81bc5e56.png";